import { useEffect, Suspense } from 'react';
import { useParams } from 'react-router-dom';

import { PresentationContainer } from '@Components/index';
import { useAppDispatch } from '@Hooks/index';
import { useGetUserInfoMutation } from '@Store/api/userApiSlice';
import { userInfoActions } from '@Store/slices/userInfoSlice';
import { useGetHrmRequestFormQuery } from '@Store/api/basicHrmApiSlice';
import approveFormComponents from './approveFormComponents';

const HRMRequestApproveForm: React.FC = () => {
  const { taskId, requestId } = useParams<{
    taskId: string;
    requestId: string;
  }>();
  const dispatch = useAppDispatch();

  const { data, isSuccess } = useGetHrmRequestFormQuery(requestId!);
  const [getUser] = useGetUserInfoMutation();

  useEffect(() => {
    if (data?.empNumber) {
      getUser({ empNo: data.empNumber })
        .unwrap()
        .then((user) => {
          dispatch(userInfoActions.setCreatedUserRequest(user));
        });
    }
  }, [data?.empNumber]);

  if (!isSuccess || !data) {
    return null;
  }

  const ApproveFormComponent = approveFormComponents[data?.requestTypeID];

  return (
    <PresentationContainer fullHeight>
      {ApproveFormComponent ? (
        <Suspense fallback={<div>Loading...</div>}>
          <ApproveFormComponent taskId={taskId!} formData={data} />
        </Suspense>
      ) : (
        <div>Something went wrong. Please, try again later.</div>
      )}
    </PresentationContainer>
  );
};

export default HRMRequestApproveForm;
